import * as React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function CallToAction() {
  return <section id="call-to-action" className="w-full bg-secondary py-20 md:py-32 px-6 flex flex-col items-center justify-center relative overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,var(--color-secondary-foreground)_0%,transparent_100%)] opacity-[0.03] pointer-events-none" />

      <div className="max-w-4xl mx-auto text-center flex flex-col items-center relative z-10">
        <h2 className="font-sans font-extrabold text-4xl md:text-6xl lg:text-7xl text-secondary-foreground tracking-tight leading-tight">
          Schedule Your Inspection
        </h2>
        
        <p className="mt-6 text-lg md:text-xl text-secondary-foreground/80 max-w-2xl font-medium leading-relaxed">
          Ensure your property meets all safety and compliance standards with our comprehensive, industry-leading inspection services.
        </p>
        
        <div className="mt-12">
          <Link to="#">
            <Button size="lg" className="relative group overflow-hidden rounded-md bg-primary text-primary-foreground border-none h-14 px-8 transition-all duration-400 ease-out hover:scale-[1.02] hover:shadow-[0_0_25px_var(--color-primary)]">
              {}
              <span className="absolute inset-0 bg-gradient-to-b from-primary-foreground/30 to-transparent opacity-60 group-hover:opacity-100 transition-opacity duration-400 ease-out pointer-events-none" />
              
              <span className="relative z-10 flex items-center gap-2 font-bold text-lg tracking-wide">
                Book Now <ArrowRight className="size-5 transition-transform duration-400 ease-out group-hover:translate-x-1" />
              </span>
            </Button>
          </Link>
        </div>
        
        <div className="mt-20 md:mt-28">
          <p className="font-mono text-xs md:text-sm text-secondary-foreground/40 uppercase tracking-widest">
            LIC #INS-2024-98765-TX • ISO 9001:2015 CERTIFIED
          </p>
        </div>
      </div>
    </section>;
}